import * as React from 'react';
import * as I18n from 'i18n-js';
import RecentArticles from './recent_articles';
import HomepageCategories from '../homepage_categories';
import HomepageCategoriesV2 from '../homepage_categories_v2';
import HomepageCuratedSetRow from '../homepage_curated_set_row';
import SellInstrumentCallout from './sell_instrument_callout';
import HomepageMosaic from './homepage_mosaic';
import RoughEdgeSection from './rough_edge_section';
import DownloadAppCallout from './download_app_callout';
import HomepageNewsletter from './homepage_newsletter';

import RecentlyViewedListings from '@reverbdotcom/commons/dist/cms/components/recently_viewed_listings';

import ArticleCollection from '@reverbdotcom/commons/dist/cms/components/article_collection';
import CspCollection from '@reverbdotcom/commons/dist/cms/components/csp_collection';
import CmsListingsCollection from '@reverbdotcom/commons/dist/cms/components/cms_listings_collection';
import SearchHeader from '@reverbdotcom/commons/dist/cms/headers/search_header';

import { withUserContext, IUserContext } from '@reverbdotcom/commons/dist/components/user_context_provider';
import { isExperimentEnabled } from '@reverbdotcom/commons/dist/user_context_helpers';
import { reverb_search_CSPSearchRequest_Sort } from '../../../schemas/rql';
import { experiments, US_CON_CODE } from '../../shared/constants';

const ARTICLE_IDS = ['4904', '4896', '4894', '4887', '4883', '4907'];
const DEFAULT_HEADER_IMAGE =
'https://reverb-res.cloudinary.com/image/upload/s--ygGlXocJ--/c_scale,q_auto:good,w_1600/v1579193425/HomepageHero-1_gr0del.jpg';
const MOBILE_HEADER_IMAGE = 'https://reverb-res.cloudinary.com/image/upload/s--Q2aQifT7--/c_scale,q_auto:eco,w_800/v1579193425/01022020-Homepage1_ji19vh.jpg';

export class LoggedOutHomepage extends React.Component<IUserContext, {}> {
  renderSearchHeader() {
    if (isExperimentEnabled(this.props.user, 'hide_search_header')) { return null; }
    return (
      <SearchHeader
        subtitle={I18n.t('discovery.homepage.searchHeader.subtitle')}
        title={I18n.t('discovery.homepage.searchHeader.title')}
        imageUrl={DEFAULT_HEADER_IMAGE}
        secondaryImageUrl={MOBILE_HEADER_IMAGE}
        renderSearchSuggestion
      />
    );
  }

  renderMosaic() {
    if (!isExperimentEnabled(this.props.user, experiments.DISCO_MOSAIC)) { return false; }
    if (this.props.user.shippingRegionCode !== US_CON_CODE) { return false; }

    return <HomepageMosaic />;
  }

  renderTrendingArticles() {
    if (this.props.user.locale !== 'en') { return null; }
    return (
      <ArticleCollection
        title={I18n.t('discovery.homepage.loggedOutNew.trendingArticles')}
        articleIds={ARTICLE_IDS}
        ssr={false}
      />
    );
  }

  renderCategories() {
    if (isExperimentEnabled(this.props.user, experiments.HOMEPAGE_CATEGORIES_V2)) {
      return <HomepageCategoriesV2 noTitle />;
    }

    return <HomepageCategories noTitle />;
  }

  render() {
    return (
      <div className="homepage bg-white">
        {this.renderSearchHeader()}
        <div className="pt-half">
          <RecentlyViewedListings
            title={I18n.t('discovery.recentlyViewed.title')}
            largeTiles
          />
        </div>
        <h2 className="homepage__subheading">
          {I18n.t('discovery.homepage.loggedOutNew.shopByCategory')}
        </h2>
        {this.renderCategories()}
        {this.renderMosaic()}
        <RoughEdgeSection>
          <h2 className="homepage__subheading">
            {I18n.t('discovery.homepage.loggedOutNew.demos')}
          </h2>
          <RecentArticles
            title={I18n.t('discovery.homepage.loggedOutNew.latestArticles')}
          />
          <div className="homepage-container__component-wrapper">
            {this.renderTrendingArticles()}
          </div>
        </RoughEdgeSection>
        <h2 className="homepage__subheading">
          {I18n.t('discovery.homepage.loggedOutNew.handpicked')}
        </h2>
        {this.props.user.shippingRegionCode === US_CON_CODE &&
          <HomepageCuratedSetRow />
        }
        <div className="homepage-container__component-wrapper">
          <CspCollection
            collectionId="67539"
            title={I18n.t('discovery.homepage.staffPicksCSPs')}
            ssr={false}
            ctaTargetHref="/collection/reverb-staff-picks"
            sort={reverb_search_CSPSearchRequest_Sort.QUALITY_DESC}
          />
        </div>
        <div className="homepage-container__component-wrapper">
          <HomepageNewsletter signupReason="loggedinhomepage" />
        </div>
        <CmsListingsCollection
          ctaTargetHref="/marketplace?condition=used"
          conditionSlugs={['used']}
          title={I18n.t('discovery.homepage.newestListings.title')}
          userShippingRegion={this.props.user.shippingRegionCode}
          maxCount={12}
          largeTiles
        />
        <div className="scaling-mt-7">
          <SellInstrumentCallout />
        </div>
        <div className="bg-white bg--darken scaling-pb-3" />
        <DownloadAppCallout />
      </div>
    );
  }
}

export default withUserContext(LoggedOutHomepage);



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/homepage/logged_out.tsx